import { render, staticRenderFns } from "./CategoryFormModal.vue?vue&type=template&id=70a63b14&"
import script from "./CategoryFormModal.vue?vue&type=script&lang=js&"
export * from "./CategoryFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports